<script>
import utils from '@/utils/common';

import UserTile from '@/components/UserTile.vue';
import EllipsisMenu from '@/components/EllipsisMenu.vue';
import PersonalStatTile from '@/components/personal/PersonalStatTile.vue';
import NotificationCount from '@/components/base/NotificationCount.vue';
import AvatarEditable from '@/components/AvatarEditable.vue';

export default {
  name: 'CompanyTile',
  components: {AvatarEditable, EllipsisMenu, UserTile, PersonalStatTile, NotificationCount }, // eslint-disable-line
  props: {
    item: {
      type: Object,
      required: true,
    },
    menu: Array,
  },
  computed: {
    currUser() { return this.$store.state.auth.user ?? {}; },
    notificationCount() {
      const getter = this.$store.getters['notification/itemIdsByFilter'];
      return getter({ companyId: this.item.id }).length;
    },
  },
  methods: {
    formatStorageSize(val) {
      return utils.formatStorageSize(val);
    }
  },
};
</script>

<template lang="pug">
  .b-company-tile
    ._labels
      ._label.-green(v-if="item.owner.id === currUser.id") Моя компания
    ._main
      ._top
        AvatarEditable._avatar(:avatar="item.avatar" :editable="false" placeholder="no-avatar-project")
        router-link._title(:to="{ name: 'company-departments', params: { companyId: item.id } }") {{ item.name }}
        ._actions
          NotificationCount(:count="notificationCount")
          //Bookmark(category="project" :id="project['@id']")
          EllipsisMenu(:items="menu")
      ._middle
        UserTile._author(:user="item.owner" label="Руководитель")
    template(v-if="item.owner.tariff")
      PersonalStatTile._stat(
        title="Проекты"
        unit="проектов"
        color="#19DAC6"
        :value="item.owner.projectCount"
        :max="item.owner.tariff.maxProjects"
      )
      PersonalStatTile._stat(
        title="Хранилище"
        unit="ГБ"
        color="#FFB27B"
        :value="formatStorageSize(item.owner.storageCount)"
        :max="formatStorageSize(item.owner.tariff.maxStorage)"
      )

</template>

<style scoped lang="scss">
.company-tile {
  padding: 45px 32px;
  background-color: var(--color-white);
  box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
  border-radius: 8px;
  color: var(--color-super-dark);
  position: relative;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 30px;

  &__avatar {
    width: 40px;
    height: 40px;
    border-width: 2px;
    border-radius: 16px;
  }

  &__labels {
    position: absolute;
    top: -10px;
    left: 32px;
    display: flex;
    gap: 10px;
  }

  &__label {
    font-size: 12px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: 0.03em;
    color: #FFFFFF;
    border-radius: 4px;
    padding: 0 14px;
    box-sizing: border-box;
    height: 20px;

    &--green { background: #5AC169; }
    &--yellow { background: #F9D208; }
  }

  &__top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    margin-bottom: 70px;
  }

  &__actions {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
  }

  &__title {
    font-size: 18px;
    line-height: 24px;
    transition: color 0.3s;
    margin-right: auto;
    &:hover {
      color: var(--color-hover);
    }
  }

  &__author {
    //position: relative;
    //margin-bottom: 30px;
  }

  @media (max-width: 1600px) {
    grid-template-columns: 1fr 1fr;

    &__main {
      grid-column: 1 / -1;
    }
  }

  @media (max-width: 968px) {
    grid-template-columns: 1fr;
  }

  @media (max-width: 768px) {
    &__top {
      margin-bottom: 12px;
    }

    &__title {
      font-size: 16px;
      line-height: 24px;
    }
  }

  @media (max-width: 400px) {
    &__stat {
      flex-direction: column;
    }
  }
}
</style>
